<template>
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.9682 11.6245V11.3762C17.8937 11.2234 15.5714 11.0897 13.7174 9.28505C11.9017 7.43262 11.787 5.1123 11.6341 0.0419922H11.3761C11.2232 5.1123 11.0894 7.43262 9.29275 9.28505C7.43878 11.0993 5.11653 11.2234 0.0419922 11.3762V11.6245C5.10697 11.7772 7.43878 11.9109 9.29275 13.7156C11.0989 15.568 11.2232 17.8883 11.3761 22.9587H11.6341C11.787 17.8883 11.9113 15.568 13.7174 13.7156C15.5714 11.9014 17.8937 11.7772 22.9682 11.6245Z"
      fill=""
    />
  </svg>
</template>
